import { Select as ChakraSelect, SelectProps as ChakraSelectProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import DisplayNames from './enums';

import { Icon } from 'index';
import { forwardRef } from 'system';
import COLORS from 'theme/colors';

type SelectSizes = 'xs' | 'sm' | 'md' | 'lg';
type SelectVariants = 'basic' | 'outline' | 'ghost' | 'unstyled';

export const selectSizes: SelectSizes[] = ['xs', 'sm', 'md', 'lg'];
export const selectVariants: SelectVariants[] = ['basic', 'outline', 'ghost', 'unstyled'];
interface SelectPropTypes {
  size?: string;
  variant?: string;
}
const propTypes = {
  size: PropTypes.oneOf(selectSizes),
  variant: PropTypes.oneOf(selectVariants)
};
const defaultProps = {
  size: 'md',
  variant: 'basic',
  isDisabled: false,
  iconColor: COLORS.black.lighter
};

export type SelectProps = Omit<ChakraSelectProps, 'size' | 'variant'> & SelectPropTypes;

const Select = forwardRef<SelectProps, 'select'>(
  (props: SelectProps & typeof defaultProps, ref): React.ReactElement => {
    return <ChakraSelect icon={<Icon type="Chevron" />} ref={ref} {...props} />;
  }
);

Select.displayName = DisplayNames.Select;
Select.propTypes = propTypes;
Select.defaultProps = defaultProps;

export default Select;
